module.exports = __webpack_public_path__ + "static/3dac71eb-afa7-4c80-97f0-599202772905-4a334318c1d098aed2078f0229d8d2d5.woff2";